<template>
  <div class="prices">

    <!--    <div class="container" style="margin-bottom: 20px;">-->
    <!--      <div class="row search">-->
    <!--        <div class="col-sm-6 col-7">-->
    <!--          <input type="text"-->
    <!--                 name="name"-->
    <!--                 class="search-input"-->
    <!--                 :placeholder="Lang.get('js.services.search')"-->
    <!--                 v-model="filters.name"-->
    <!--          >-->
    <!--        </div>-->
    <!--        <div class="button-clear col-5" v-if="filters.name">-->
    <!--          <div @click="clearFilter" class="discount-button orange search-btn">{{Lang.get('js.services.all')}}</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="container" v-if="Object.keys(data).length > 0">
      <div class="row">
        <div class="col-12 col-lg-3 left d-none d-lg-block">
          <div class="price-menu">
            <ul>
              <li v-for="(category, key) in reorderedArray"
                  :key="key"
                  :class="{ active: currentCategory === key || currentCategory == category.name}"
                  @click="currentCategory = key">{{ category.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-lg-9 block-info">
          <div class="static-info">
            <p>{{ Lang.get('js.services.dop') }}</p>
          </div>
          <template v-for="(item, key) in reorderedArray"
          >
            <ul class="d-block d-lg-none mobile-category">
              <li @click="toggleCategory(key)"
                  :class="{ active: currentCategory === key}">{{ item.name }}
              </li>
            </ul>
            <div v-if="key === currentCategory" class="my-table-info">
                            <table>
                              <thead>
                              <tr>
                                <th>{{ Lang.get('js.services.code') }}</th>
                                <th>{{ Lang.get('js.services.type') }}
                                </th>
                                <!--                <th>Вид биоматериала-->
                                <!--                </th>-->
                                <th>{{ Lang.get('js.services.time') }}
                                </th>
                                <th>{{ Lang.get('js.services.price') }}</th>
                                <th v-if="checkDiscount(item.services)">{{ Lang.get('js.services.buy') }}</th>
                                <th v-else>{{ Lang.get('js.services.buy_without_discount') }}</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr>
                                <td colspan="4"><strong>{{ item.name }}</strong>
                                </td>
                              </tr>
                              <tr v-for="(service, index) in item.services">
                                <td>
                                  {{ service.code }}
                                </td>
                                <td style="width: 570px;">
                                  <a :href="'/' + service.alias.url"
                                     :title="service.name">
                                    {{ service.name }}</a>
                                </td>
                                <td>
                                  {{ service.lead_time ? service.lead_time : '-' }}
                                </td>
                                <td>
                                  {{ service.price }}
                                </td>
                                <td @click="goToCart(service)" style="cursor: pointer">
                                  <span class="my-button cart-icon table-my-button" style="text-align: center"
                                        v-html="getPriceWithDiscount(service.price) + ' грн.'"
                                        v-if="service.discount === 1"
                                  ></span>
                                  <span class="my-button cart-icon table-my-button" style="text-align: center"
                                        v-html="service.price + ' грн.'"
                                        v-else
                                  ></span>
                                </td>
                              </tr>
                              </tbody>
                            </table>

<!--              <div class="new-service-item" v-for="(service, index) in item.services">-->
<!--                <div class="row align-items-center">-->
<!--                  <div class="col-2">-->
<!--                    <div class="image">-->
<!--                      <img src="/local_image/serv-preview.jpg" alt="">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="col-8">-->
<!--                    <div class="title">-->
<!--                      <a :href="'/' + service.alias.url"-->
<!--                         :title="service.name">-->
<!--                        {{ service.name }}</a>-->
<!--                    </div>-->

<!--                    <div class="text">-->
<!--                      Далеко-далеко за словесными горами в стране гласных и согласных живут рыбные тексты. Вдали от всех-->
<!--                      живут они в буквенных домах на берегу... <a :href="'/' + service.alias.url" class="ml-3 my-link">Подробнее</a>-->
<!--                    </div>-->

<!--                    <div class="d-flex align-items-center">-->
<!--                      <div class="price" :class="service.discount === 1 ? 'discount' : ''">{{ service.price }} грн.-->
<!--                      </div>-->
<!--                      <div v-if="service.discount === 1" class="price with-discount">-->
<!--                        {{ getPriceWithDiscount(service.price) }} грн.-->
<!--                      </div>-->
<!--                    </div>-->


<!--                  </div>-->
<!--                  <div class="col-2">-->
<!--                    <div class="my-button" @click="goToCart(service)">В корзину</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="container" style="font-size: 1.9rem;" v-else>{{ Lang.get('js.services.no_result') }}</div>
  </div>

</template>

<script>
var urlParams = new URLSearchParams(window.location.search);
export default {
  name: 'services-list',
  data() {
    return {
      currentCategory: 0,
      Lang,
      defaultLanguage,
      data: {},
      isOpen: false,
      filters: {
        name: urlParams.get('name') ? urlParams.get('name') : '',
      },
      cart: window.cart
    }
  },
  watch: {
    filters: {
      handler: _.debounce(
          function () {
            this.updateData();
          }, 500
      ),
      deep: true
    },
  },

  computed: {
    // Вычисляемое свойство для пересборки массива
    reorderedArray() {
      // Копируем исходный массив данных
      let newArray = this.data.slice();
      // Ищем индекс элемента с названием, равным targetName
      const targetIndex = newArray.findIndex(
          item => item.name === 'Пакети аналізів + консультація лікаря'
      );
      if (targetIndex !== -1) {
        // Если элемент найден, удаляем его из текущей позиции
        const targetItem = newArray.splice(targetIndex, 1)[0];
        // Вставляем его в начало массива
        newArray.unshift(targetItem);
      }
      // Возвращаем пересобранный массив
      return newArray;
    },
  },

  methods: {
    toggleCategory(key) {
      if (this.currentCategory === key) {
        this.currentCategory = '';
      } else {
        this.currentCategory = key;
      }
    },
    getPriceWithDiscount(initPrice) {
      initPrice = Math.round(parseFloat(initPrice * (100 - 10))) / 100;
      return initPrice;
    },
    // goToCart(code) {
    //     let url = 'http://artmediuz.medcloud.pro/?tests=' + code + '&tab=cart';
    //     window.open(url, '_blank');
    // },
    goToCart(service) {
      let price_with_discount = service.price;
      ;
      if (service.discount === 1) {
        price_with_discount = this.getPriceWithDiscount(service.price);
      }

      this.cart.addToCart(service, price_with_discount);
    },
    updateData() {
      this.loading = true;
      let prefix = Lang.locale === this.defaultLanguage ? '' : '/' + Lang.locale;
      axios.post(prefix + '/services/search', this.filters).then(res => {
        this.data = res.data.result;
        if (this.filters.name) {
          let key;
          for (var k in this.data) {
            key = k;
            break;
          }
          this.currentCategory = this.data[key].name;
        } else {
          if (document.documentElement.clientWidth <= 991) {
            this.currentCategory = '';
          } else {
            this.currentCategory = 0;
          }

        }
      }).catch(err => this.loading = false);

      this.updateUrl();

    },
    updateUrl() {
      this.filters.name ? urlParams.set('name', helpers.clearStringForUrl(this.filters.name)) : urlParams.delete('name');

      let url = urlParams.toString();

      if (url) {
        history.pushState(null, null, location.protocol + '//' + location.host + location.pathname + '?' + urlParams.toString());
      } else {
        history.pushState(null, null, location.protocol + '//' + location.host + location.pathname);
      }
    },
    clearFilter() {
      this.filters.name = '';
      this.currentCategory = 0;
    },

    checkDiscount(servicesArray) {
      let hasDiscount = true;
      servicesArray.forEach((service) => {
        if (service.discount === 0) {
          hasDiscount = false;
        }
      });

      return hasDiscount;
    }

  },
  mounted() {
    this.filters.name = '';
    this.filters.name = urlParams.get("name");
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/service/ServicesList.vue